import React, { lazy, Suspense } from 'react';
import { StyledOpeningHours, StyledOpeningHoursContainer, StyledOpeningHoursHeading } from './styles';

const Markdown = lazy(() => import('components/elements/Markdown'));

const DS_LocationOpeningHours = ({ data, openingHoursTranslation, newOpeningHours, daysOftheWeekTranslations }) => {
  const hasNewOpeningHours = newOpeningHours?.some(hours => hours);
  return (
    <StyledOpeningHoursContainer>
      {hasNewOpeningHours ? (
        <>
          <StyledOpeningHoursHeading variant="DS_copyMediumBold" component="p">
            {openingHoursTranslation}
          </StyledOpeningHoursHeading>
          <StyledOpeningHours>
            <ul>
              {Object.entries(daysOftheWeekTranslations).map(([dayKey, dayTranslation], index) => {
                const hours = newOpeningHours[index];
                if (!hours) return null;
                return (
                  <li key={dayKey}>
                    <span>{dayTranslation} </span>
                    {hours.map(hour => (
                      <span key={hour}>{hour}</span>
                    ))}
                  </li>
                );
              })}
            </ul>
          </StyledOpeningHours>
        </>
      ) : (
        <>
          <StyledOpeningHoursHeading variant="DS_copyMediumBold" component="p">
            {openingHoursTranslation}
          </StyledOpeningHoursHeading>
          <StyledOpeningHours>
            <Suspense fallback={<div />}>
              <Markdown>{data.markdown.html}</Markdown>
            </Suspense>
          </StyledOpeningHours>
        </>
      )}
    </StyledOpeningHoursContainer>
  );
};

export default DS_LocationOpeningHours;
